import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { APPLICATION_SEARCH_URL } from "../ApiUrls";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class ApplicationSearchRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  url = APPLICATION_SEARCH_URL;

  body = {
    applicationId: "",
    startDate: "",
    status: "",
    page: 0,
    size: 20,
    sortBy: "created",
    sortDirection: "DESC",
  };

  constructor(searchCriteria) {
    super();
    this.body = {
      ...this.body,
      ...searchCriteria,
    };
  }

  getMethod = () => this.method;

  // eslint-disable-next-line class-methods-use-this
  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
